module.exports = __webpack_public_path__ + "img/login-new.85e0a3c5.jpg";